var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQamSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 30,
    viewBox: "0 0 38 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_3658_677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9531 4.125H14.3593C15.5781 4.125 16.6093 5.15625 16.6093 6.375C16.6093 7.21875 16.1406 7.96875 15.3437 8.34375L14.4531 8.8125V9C14.4531 9.42188 14.125 9.75 13.7031 9.75C13.3281 9.75 12.9531 9.42188 12.9531 9V8.34375C12.9531 8.0625 13.1406 7.78125 13.375 7.6875L14.6875 7.03125C14.9218 6.89062 15.1093 6.65625 15.1093 6.375C15.1093 5.95312 14.7812 5.625 14.3593 5.625H12.9531C12.625 5.625 12.3437 5.90625 12.3437 6.23438C12.3437 6.65625 12.0156 6.98438 11.5937 6.98438C11.1718 6.98438 10.8437 6.65625 10.8437 6.23438C10.8437 5.0625 11.7812 4.125 12.9531 4.125ZM12.7656 11.25C12.7656 10.7344 13.1875 10.3125 13.7031 10.3125C14.2656 10.3125 14.6406 10.7344 14.6406 11.25C14.6406 11.7656 14.2656 12.1875 13.7031 12.1875C13.1875 12.1875 12.7656 11.7656 12.7656 11.25ZM13.75 16.5C12.8593 16.5 12.0156 16.4062 11.1718 16.2188C9.76559 17.1094 7.70309 18 5.12497 18C4.65622 18 4.23434 17.7656 4.09372 17.2969C3.90622 16.875 3.95309 16.4062 4.28122 16.0312C4.32809 16.0312 5.35934 14.9062 6.10934 13.4062C4.79684 12 3.99997 10.2188 3.99997 8.25C3.99997 3.70312 8.35934 0 13.75 0C19.0937 0 23.5 3.70312 23.5 8.25C23.5 12.8438 19.0937 16.5 13.75 16.5ZM21.25 8.25C21.25 4.96875 17.875 2.25 13.75 2.25C9.57809 2.25 6.24997 4.96875 6.24997 8.25C6.24997 9.9375 7.04684 11.1562 7.74997 11.8594L8.87497 13.0312L8.12497 14.4844C7.93747 14.7656 7.74997 15.0938 7.56247 15.4219C8.40622 15.1875 9.20309 14.8125 9.99997 14.2969L10.7968 13.8281L11.6875 14.0156C12.3906 14.2031 13.0468 14.25 13.7031 14.25C17.875 14.25 21.25 11.5781 21.25 8.25ZM25 8.29688V8.25C25 7.5 24.8593 6.75 24.6718 6.04688C29.875 6.23438 34 9.84375 34 14.25C34 16.2188 33.1562 18 31.8437 19.4062C32.5937 20.9062 33.625 22.0312 33.6718 22.0312C34 22.4062 34.0468 22.875 33.8593 23.2969C33.7187 23.7656 33.2968 24 32.8281 24C30.25 24 28.1875 23.1094 26.7812 22.2188C25.9375 22.4062 25.0937 22.5 24.25 22.5C20.4062 22.5 17.0781 20.625 15.4843 17.9062C16.2812 17.8125 17.0781 17.625 17.7812 17.3438C19.0937 19.125 21.4843 20.25 24.25 20.25C24.9062 20.25 25.5625 20.2031 26.2656 20.0156L27.1562 19.8281L27.9531 20.2969C28.75 20.8125 29.5468 21.1875 30.3906 21.4219C30.2031 21.0938 30.0156 20.7656 29.8281 20.4844L29.0781 19.0312L30.2031 17.8594C30.9062 17.1562 31.75 15.9375 31.75 14.25C31.75 11.1562 28.75 8.625 24.9531 8.29688H25Z",
    fill: "#EDF2F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_3658_677",
    x: 0.906219,
    y: 0,
    width: 36.1406,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3658_677"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3658_677",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3658_677"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQamSupport);
export default ForwardRef;